import styledComp from 'styled-components';
import styled from '@mui/styles/styled';
import { DialogActions, DialogTitle } from '@mui/material';
import TextField from '@mui/material/TextField';

import { Colors, Styling } from '../../../constants';

const HeaderBaseStyle = `
  height: 22px;
  margin-bottom:${Styling.DEFAULT_SPACING}px;
`;

export const TextHeader = styledComp.h2`
  ${HeaderBaseStyle}
`;

export const ActionContainer = styledComp.div`
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    margin-left: ${Styling.DEFAULT_SPACING}px;
  }
`;

export const DialogContentContainer = styledComp.div`
  margin-left: ${Styling.DEFAULT_SPACING}px;
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const PublishProfilesContainer = styledComp.div`
  display: flex;
  overflow-y: auto;
  height: 262px;
  border-bottom: 1px solid ${Colors.BLACK_10};
  padding-right: ${Styling.DEFAULT_SPACING}px;
  padding-top: ${Styling.DEFAULT_SPACING}px;
`;

export const SelectedAssetsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  padding-top: ${Styling.DEFAULT_SPACING}px;
  padding-bottom: ${Styling.DEFAULT_SPACING}px;
`;

export const SelectedAssetsItemList = styledComp.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  max-height: 250px;
  overflow-y: auto;
  background-color: ${Colors.SELECTED_ITEM};
`;

export const SelectedAssetsInfoText = styledComp.span`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: ${Styling.DEFAULT_SPACING}px;
`;

export const SelectedAssetText = styledComp.span`
  display: flex;
  flex-grow: 1;
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const SelectedDeleteAssetText = styledComp.span`
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const DialogHeaderTitle = styledComp.span`
  font-weight: bold;
  font-size: 20px
`;

export const DialogHeader = styledComp.div`
  display: flex;
  align-items: center;

  padding: ${Styling.DEFAULT_SPACING}px;
  background-color: #f7f7f7;
  height: 78px;

  > * {
    margin-right: ${Styling.DEFAULT_SPACING}px !important;
  }
`;

export const DialogActionsOverride = styled(DialogActions)({

});

export const DialogTitleOverride = styled(DialogTitle)({
  'background-color': '#f7f7f7',
});

export const TextFieldOverride = styled(TextField)({
  width: '362px',
  'background-color': 'white',
});
